import React from "react";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import quizBanner from "../../../../styles/img/quiz-banner.png";
import Lexus from "../../../../styles/img/lexus-car.jpg";
import ToyotaCar from "../../../../styles/img/toyota-car.png"
import { UiBannerBottomBar } from "../../components/common/UiBannerBottomBar";
import KnowledgeInnerBanner from "./Views/KnowledgeInnerBanner";
import { UiContentCol, UiContentWr } from "../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer";
import Footer from "../../components/footer/Footer";
import { UiBlueBox } from "../../../_uiComponents/common/UiBlueBox";
import { Button } from "react-bootstrap";
import { QuestionLinks } from "../../../_uiComponents/common/QuestionLinks";
import { CircleTick } from "../../../../styles/img/svg/CircleTick";
import { UiQuestionWrapper } from "../../../_uiComponents/common/UiQuestionWrapper";
import { NeedAHelp } from "./Views/NeedAHelp";
import { McqQuestions } from "./Views/McqQuestions";
import { useNavigate } from "react-router-dom";
import ToyotaInnerBanner from '../../../../styles/img/knowledge-inner-banner.png'
import ToyotaNewAygoBanner from "../../../../styles/img/new-aygo-x.png"


export const TemplateImageMCQ = (props) => {
    let navigate = useNavigate();
    const nextQuiz = () => {
        let path = `../../ui/correct-image-q-template`;
        navigate(path, { replace: true });
    }

    return (
        <>
            <UiMainWrapper>
                <TopHeader />

                <KnowledgeInnerBanner
                    innerBanner={ToyotaNewAygoBanner}
                    title="The New Aygo X"
                    description="Is your knowledge up to scratch?"
                    className="sb-knowldg-inner-banner" />

                <UiBannerBottomBar
                    prevPage="Learn"
                    prevPageLink=""
                    currentPage="  Q1 Product Quiz"
                    currentPageLink="" />

                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-mcq-template-page">
                        <UiContentCol>
                            <UiSingleRow>
                                <UiCol lg="3" className="sb-img-q-template-page__links">

                                    <UiBlueBox >
                                        <p>Questions Remaining</p>
                                        <h3>4</h3>
                                    </UiBlueBox>

                                    <QuestionLinks className="sb-green-links">
                                        <li className="active"><a href="#"> <CircleTick /> My Progress</a></li>
                                        <li><a href="#"><CircleTick />  Introduction</a></li>
                                        <li><a href="#"><CircleTick />  Introduction Section 2</a></li>
                                        <li><a href="#"><CircleTick />  Section 3</a></li>
                                        <li><a href="#"><CircleTick />  Section 4</a></li>
                                        <li><a href="#"><CircleTick />  Section 5</a></li>
                                    </QuestionLinks>


                                </UiCol>
                                <UiCol lg="9" className="sb-img-q-template-page__content">
                                    <UiQuestionWrapper>
                                        <h3><span>Question 1:</span> Which areas of the Aygo X Edge are correct in the following choices?</h3>

                                        <p className="sb-1-instruction">Select one of the following:</p>
                                        <UiSingleRow>
                                            <UiCol lg="8">
                                                <img src={ToyotaCar} />
                                            </UiCol>

                                        </UiSingleRow>

                                        <McqQuestions
                                            title="Answer Title"
                                            description="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua."
                                            id="q1"
                                            name="radio"
                                            for="q1"
                                        />

                                        <McqQuestions
                                            title="Answer Title"
                                            description="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua."
                                            id="q2"
                                            name="radio"
                                            for="q2"
                                        />


                                        <McqQuestions
                                            title="Answer Title"
                                            description="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua."
                                            id="q3"
                                            name="radio"
                                            for="q3"
                                        />


                                        <McqQuestions
                                            title="Answer Title"
                                            description="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua."
                                            id="q4"
                                            name="radio"
                                            for="q4"
                                        />

                                    <div className="row">
                                        <div className="col-4">
                                        <Button className="sb-geen-btn" onClick={nextQuiz}>Submit?</Button>
                                   
                                   </div></div>
                                    </UiQuestionWrapper>

                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiRowContainer>
                </UiContentWr>

                <NeedAHelp />

                <Footer />

            </UiMainWrapper>


        </>
    )
}